import React from 'react';
import { connect } from 'react-redux'
import IconButton from "@material-ui/core/IconButton";
import { MdClear, MdMoreVert } from 'react-icons/md';

import { MuiPickersUtilsProvider, } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';


import { DualTitleHeaderComponent } from "../../layout/HeaderComponent.js"
import { PrimaryButton, DeleteButton, SecondaryButton } from "../../styled-components/Buttons/Buttons.js";
import { RequiredTextField, NormalTextField } from "../../styled-components/TextFields/TextFields.js";

import { approveExtensionProgressReporting } from "../../../redux/actions/index"
import { calcQuarters } from '../../utilities/QuarterDates';


// CSS imports
import "../../../styles/common.css";
import "../../../styles/iron-flex-layout.css";
import "../../../styles/iron-flex-layout-classes.css";


const mapStateToProps = (state) => {
    console.log(state)
    return {
        selectedCounty: state.rootReducer.selectedCounty,
        currentGroupNarrativeM2M: state.rootReducer.currentGroupNarrativeM2M,
        currentExtension: state.rootReducer.currentExtension,
        lempgUserType: state.rootReducer.lempgUserType,
        selectedYear: state.rootReducer.selectedYear
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        approveExtensionProgressReporting: (payload, callback) => dispatch(approveExtensionProgressReporting(payload, callback)),
    }
}


class ProgressReportingExtensionsView extends React.Component {

    state = {
        openApprove: false,
        errors: [],
        validate: false,
        reasonForExtension: (this.props.currentExtension && this.props.currentExtension.reasonForExtension) || "",
        dueDate: (this.props.currentGroupNarrativeM2M && this.props.currentGroupNarrativeM2M.currentExtension && this.props.currentGroupNarrativeM2M.currentExtension.dueDate) || "",
        dueDateDisplay: (this.props.currentExtension && this.props.currentExtension.currentExtension && this.props.currentExtension.currentExtension.dueDate) || "",
        quarterTo: this.props.currentExtension && this.props.currentExtension.quarterTo,
        quarterToDisplay: (this.props.currentExtension && this.props.currentExtension.quarterTo && "Q" + parseInt(this.props.currentExtension.quarterTo.split('').reverse())),
        quarterFrom: this.props.currentExtension && this.props.currentExtension.quarterFrom,
        quarterFromDisplay: (this.props.currentExtension && this.props.currentExtension.quarterFrom && "Q" + parseInt(this.props.currentExtension.quarterFrom.split('').reverse())),
        type: this.props.currentExtension && this.props.currentExtension.type
    }

    constructor(props, context) {
        super(props, context);

        if (this.props.currentExtension) {
            this.state.dueDateDisplay = moment(this.state.dueDate, "YYYY-MM-DD").format("MM-DD-YYYY");

            // this.state.dueDateDisplay = this.props.currentExtension.dueDate && (new Date(this.toUTC(new Date(this.props.currentExtension.dueDate))));

        }
        this.calcQuarters = calcQuarters.bind(this);
    }

    toUTC = (date) => {
        var newDate = new Date();
        newDate.setTime(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));
        return newDate;
    }

    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    }

    goBack = () => {
        this.props.history.goBack()
    }

    handleClose = (variable) => {
        this.setState({
            [variable]: false
        });
    };

    openDialog = (variable) => {
        this.setState({
            [variable]: true
        });
    }

    approveExtensionProgressReporting = () => {
        this.props.approveExtensionProgressReporting(this.state, () => {
            this.goBack()
        });
    }

    adjustExtension = () => {
        this.props.history.push("/extensions/adjust");
    }

    deniedExtension = () => {
        this.props.history.push("/extensions/denied");
    }

    getType = (str) => {
        if (str == "FINANCIAL_REIMBURSEMENT") return "Financial Reimbursement";
        if (str == "PROGRESS_REPORTING") return "Progress Reporting";

        return ""
    }

    getQuarterEndDate = (quarter) => {
        if (!quarter) return

        var obj = calcQuarters(this.props.selectedYear);

        return obj[quarter].end;
    }

    _convertToTitleCase = (str) => {
        str = str.toLowerCase();
        return str.replace(/(^|\s)\S/g, function (t) { return t.toUpperCase() });
    }

    componentDidUpdate() { }

    render() {

        const quarterSubheaderTitle = "Q" + parseInt(this.props.currentGroupNarrativeM2M.quarter.split("").reverse())

        return (

            <div className="layout vertical full-height">
                <Dialog
                    open={this.state.openApprove}
                    onClose={() => this.handleClose("openApprove")}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <div style={{ maxWidth: "320px" }}>
                        <DialogTitle id="alert-dialog-title">Approve extension</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                You are about to <b>approve</b> an extension for <b> {this._convertToTitleCase(this.props.currentExtension && this.props.currentExtension.group)} </b> County. This will also remove their extension request from the list and cannot be undone. Are you sure you want to do this?
                            </DialogContentText>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={() => this.handleClose("openApprove")} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={() => this.approveExtensionProgressReporting()} color="primary" autoFocus>
                                Approve
                            </Button>
                        </DialogActions>
                    </div>
                </Dialog>

                <DualTitleHeaderComponent
                    icon={
                        <IconButton
                            aria-label="close"
                            onClick={this.goBack}
                        >
                            <MdClear className="icon" />
                        </IconButton>

                    }
                    titleBig={<span>Extensions</span>}
                    
                    titleSmall={<span style={{ textTransform: "capitalize" }}>{this.props.selectedYear} • {quarterSubheaderTitle} • {this.props.currentExtension && this.props.currentExtension.group} </span>}
                      />

                <div className="flex form-shell container-overflow-y">

                    <div className="layout horizontal center section-title form-margin">Entry Details</div>
                    <div className="layout horizontal wrap">
                        <NormalTextField value={this._convertToTitleCase(this.props.currentExtension && this.props.currentExtension.group)} id="groupName" label="County name" className="flex" InputProps={{ readOnly: true, }} custommargin="true" customtbmargin="true" InputLabelProps={{ shrink: true, }} />
                        {
                            this.state.type !== 'BY_QUARTER' ?
                        <NormalTextField value={quarterSubheaderTitle} id="extensionQuarter" label="Quarter" className="flex" InputProps={{ readOnly: true, }} custommargin="true" customtbmargin="true" InputLabelProps={{ shrink: true, }} />
                            : ""
                        }
                        <NormalTextField value={this.getType(this.props.currentExtension && this.props.currentExtension.for)} id="narrativeFrequency" label="Type" className="flex" InputProps={{ readOnly: true, }} custommargin="true" customtbmargin="true" InputLabelProps={{ shrink: true, }} />
                    </div>

                    <div className="layout horizontal center section-title form-margin">Extension Details</div>
                      {
                        this.state.type !== 'BY_QUARTER' ?
                    <div className="layout horizontal wrap">
                        <NormalTextField value={this.state.dueDateDisplay} id="extensionProposedDueDate" label="Proposed due date" className="flex" InputProps={{ readOnly: true, }} custommargin="true" customtbmargin="true" InputLabelProps={{ shrink: true, }} />

                        <NormalTextField value={this.getQuarterEndDate(this.props.currentGroupNarrativeM2M && this.props.currentGroupNarrativeM2M.quarter)} id="extensionInitialDueDate" label="Initial due date" className="flex" InputProps={{ readOnly: true, }} custommargin="true" customtbmargin="true" InputLabelProps={{ shrink: true, }} />
                    </div>
                    :
                    <div className="layout horizontal wrap">
                        <NormalTextField value={this.state.quarterFromDisplay} id="extensionQuarterFrom" label="Initial quarter completion" className="flex" InputProps={{ readOnly: true, }} custommargin="true" customtbmargin="true" InputLabelProps={{ shrink: true, }} />

                        <NormalTextField value={this.state.quarterToDisplay} id="extensionQuarterTo" label="Proposed quarter completion" className="flex" InputProps={{ readOnly: true, }} custommargin="true" customtbmargin="true" InputLabelProps={{ shrink: true, }} />
                    </div>
                      }
                    <div className="layout horizontal wrap">
                        <NormalTextField value={this.state.reasonForExtension} id="extensionReason" label="Reason" className="flex" InputProps={{ readOnly: true, }} custommargin="true" customtbmargin="true" InputLabelProps={{ shrink: true, }} />
                    </div>
                    
                </div>

                <div className="layout horizontal center-justified form-container " style={{ borderTop: "1px solid #E0E0E0" }}>
                    <div className="form-margin">

                        {/* Progress Reporting - BY_DATE - Adjust */}
                        {/* Progress Reporting - BY_QUARTER - Decline */}

                        {
                            this.state.type !== 'BY_QUARTER' ?
                        <SecondaryButton setwidth="true" onClick={() => this.adjustExtension()}>ADJUST</SecondaryButton>
                            :
                        <DeleteButton setwidth="true" onClick={() => this.deniedExtension()}>DENY</DeleteButton>
                        }    
                    </div>
                    <div className="form-margin">
                        <PrimaryButton setwidth="true" onClick={() => this.openDialog("openApprove")}>APPROVE</PrimaryButton>
                    </div>

                </div>


            </div>

        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProgressReportingExtensionsView);
